import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, ViewProps, Image } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useColors } from '../../hooks';
import { useActivityContext } from '../../hooks/use-activity.context';
import { useShowCopilotButton } from '../../hooks/use-show-copilot-button';
import { AskATeacher } from '../ask-a-teacher/ask-a-teacher';
import BugReporter from '../bug-reporter/bug-reporter';
import LinkButton from '../link-button/link-button';
import { isBigScreen } from '../media-query';

const fabImage = require('../../assets/images/fab.png');

export default function LessonPlayerFooter({ style, ...rest }: ViewProps) {
  const [showBugReporterDialog, setShowBugReporterDialog] = useState(false);
  const [showAskATeacherDialog, setShowAskATeacherDialog] = useState(false);
  const colors = useColors();
  const { t } = useTranslation();
  const { lessonInfo, handleChatBotClick } = useActivityContext();
  const { showCopilot, copilotEnabled } = useShowCopilotButton();

  if (!lessonInfo) {
    return null;
  }

  return (
    <SafeAreaView
      {...rest}
      style={[
        styles.container,
        // eslint-disable-next-line react-native/no-inline-styles
        { backgroundColor: colors.offWhite },
        style,
      ]}
      edges={['bottom']}
    >
      {!showCopilot && !copilotEnabled && (
        <LinkButton
          text={t(
            isBigScreen()
              ? 'lessons.lesson.askTeacher.title'
              : 'lessons.lesson.askTeacher.mobile'
          )}
          onPress={() => setShowAskATeacherDialog(true)}
        />
      )}
      <LinkButton
        text={t('mobile.feedback.reportBug.title')}
        onPress={() => setShowBugReporterDialog(true)}
      />
      {showCopilot && (
        <LinkButton
          text={t('oeapp.lessonPlayer.footer.askJenny')}
          onPress={handleChatBotClick}
          textStyle={[styles.bold, { color: colors.black }]}
          leftComponent={<Image source={fabImage} style={styles.chatBotFab} />}
        />
      )}
      {showAskATeacherDialog && (
        <AskATeacher
          courseId={lessonInfo.id}
          visible={showAskATeacherDialog}
          onClose={() => setShowAskATeacherDialog(false)}
        />
      )}
      {showBugReporterDialog && (
        <BugReporter
          lessonId={lessonInfo.id}
          visible={showBugReporterDialog}
          onClose={() => setShowBugReporterDialog(false)}
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingBottom: 8,
  },
  chatBotFab: {
    height: 25,
    width: 24,
    marginRight: 4,
  },
  bold: {
    fontWeight: 'bold',
    lineHeight: 14,
  },
});
